import React, { useState } from "react";
import { Sparkles, RefreshCw, Check, X } from "lucide-react";
import { Spinner } from "../../../components/Button.js";
import { generateVenueDescription } from "../../../venueTools.js";

function DescriptionGenerator({ venue, currentDescription, onAccept }) {
  const [isGenerating, setIsGenerating] = useState(false);
  const [suggestion, setSuggestion] = useState("");
  const [error, setError] = useState("");
  const [mode, setMode] = useState(null);

  const generateDescription = async (isImprovement) => {
    setIsGenerating(true);
    setError("");
    setSuggestion("");
    setMode(isImprovement ? "improve" : "generate");

    try {
      const generatedText = await generateVenueDescription({
        venue,
        currentDescription,
        improve: isImprovement,
      });

      setSuggestion(generatedText);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleAccept = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onAccept(suggestion);
    setSuggestion("");
    setMode(null);
  };

  const handleReject = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSuggestion("");
    setMode(null);
  };

  const hasDescription = currentDescription && currentDescription.trim().length > 0;

  return (
    <div className="mt-3">
      {!suggestion && !isGenerating && (
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => generateDescription(false)}
            disabled={isGenerating}
            className="inline-flex items-center gap-2 px-3 py-2 text-sm border border-border rounded-sm text-text-secondary hover:text-accent hover:border-accent hover:bg-accent-subtle transition-all duration-fast disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Sparkles size={16} strokeWidth={1.5} />
            Genereer beschrijving
          </button>
          {hasDescription && (
            <button
              type="button"
              onClick={() => generateDescription(true)}
              disabled={isGenerating}
              className="inline-flex items-center gap-2 px-3 py-2 text-sm border border-border rounded-sm text-text-secondary hover:text-accent hover:border-accent hover:bg-accent-subtle transition-all duration-fast disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <RefreshCw size={16} strokeWidth={1.5} />
              Verbeter huidige tekst
            </button>
          )}
        </div>
      )}

      {isGenerating && (
        <div className="flex items-center gap-3 p-4 bg-bg-sunken rounded-sm">
          <Spinner className="text-accent" />
          <span className="text-sm text-text-secondary">
            {mode === "improve" ? "Beschrijving verbeteren..." : "Beschrijving genereren..."}
          </span>
        </div>
      )}

      {error && (
        <div className="mt-2">
          <div className="p-3 bg-error-subtle border border-error/20 rounded-sm text-sm text-error">{error}</div>
        </div>
      )}

      {suggestion && (
        <div className="border border-border rounded-sm overflow-hidden animate-fade-in">
          <div className="px-4 py-3 bg-bg-sunken border-b border-border">
            <span className="text-xs font-medium uppercase tracking-wider text-text-secondary">
              {mode === "improve" ? "Verbeterde beschrijving" : "Gegenereerde beschrijving"}
            </span>
          </div>
          <div className="p-4 text-base leading-relaxed text-text-primary whitespace-pre-wrap">{suggestion}</div>
          <div className="flex gap-2 px-4 py-3 border-t border-border bg-bg-sunken">
            <button
              type="button"
              onClick={handleAccept}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium bg-accent text-text-inverse rounded-sm hover:bg-accent-hover transition-colors duration-fast"
            >
              <Check size={14} />
              Gebruiken
            </button>
            <button
              type="button"
              onClick={handleReject}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-text-secondary border border-border rounded-sm hover:bg-bg-sunken transition-colors duration-fast"
            >
              <X size={14} />
              Annuleren
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DescriptionGenerator;
